// extracted by mini-css-extract-plugin
export default {"container":"iqqG_G","innerContainer":"C9t2EF","title":"m2ZzPh","body":"XEhx62","error":"mhx2YL","button":"zkFmzI","isMuted":"tLLrs1"};